import { render, staticRenderFns } from "./LogoutMessageDialog.vue?vue&type=template&id=0cd26a3b"
import script from "./LogoutMessageDialog.vue?vue&type=script&lang=js"
export * from "./LogoutMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports